import React from 'react'
import Button from '../../core/button/Button'
import { formatDateBasedOnLanguage, getPhaseOfDateRange } from 'senf-shared'
import i18n from 'senf-shared/utils/i18n'
import { useTranslation } from 'react-i18next'

const PostIdeaButton = ({ideaMap, handle}) => {
    const {t} = useTranslation()
  return (
    <Button
    size="lg"
    className="w-full"
    leadingIcon={getPhaseOfDateRange(ideaMap?.startDate, ideaMap?.endDate) === "while" ? "plus-md" : undefined}
    variant="primary"
    disabled={getPhaseOfDateRange(ideaMap?.startDate, ideaMap?.endDate) !== "while"}  
    disabledNotice={getPhaseOfDateRange(ideaMap?.startDate, ideaMap?.endDate) === "before" ? `${t("global:participationNotOpenYet")} ${formatDateBasedOnLanguage(
      new Date(ideaMap?.startDate),
      i18n.resolvedLanguage,
    )}` : getPhaseOfDateRange(ideaMap?.startDate, ideaMap?.endDate) === "after" ? `${t("global:participationClosed")} ${formatDateBasedOnLanguage(
      new Date(ideaMap?.endDate),
      i18n.resolvedLanguage,
    )}` : t("global:participationNotYetScheduled")}
    text={getPhaseOfDateRange(ideaMap?.startDate, ideaMap?.endDate) === "while" ? t("util:new_male", {val: t("global:post")}) : getPhaseOfDateRange(ideaMap?.startDate, ideaMap?.endDate) === "before" ? `${t("global:participationNotOpenYet")} ${formatDateBasedOnLanguage(
      new Date(ideaMap?.startDate),
      i18n.resolvedLanguage,
    )}` : getPhaseOfDateRange(ideaMap?.startDate, ideaMap?.endDate) === "after" ? `${t("global:participationClosed")} ${formatDateBasedOnLanguage(
      new Date(ideaMap?.endDate),
      i18n.resolvedLanguage,
    )}` : t("global:participationNotYetScheduled")}
    onClick={() => handle.openAddIdea(ideaMap)}
  />
  )
}

export default PostIdeaButton